import * as React from "react";
import "./Loading.css"; //import loadingGif from "loadingCircle.gif";
//const loadingGif = require("./loadingCircle.gif")

var Loading = function Loading() {
  return /*#__PURE__*/React.createElement("div", {
    className: "lds-default"
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null)); //return (<img src={loadingGif} alt="Cargando..."/>)
  //return <div className="loading" />
};

export default Loading;